export enum TooltipColor {
    SUCCESS = 'success',
}
